import React from "react";
import { Info } from "lucide-react";

/**
 * Notice shown on a "container" company's detail tabs (partner or parent) to
 * explain that the listed records belong to related companies, not the
 * container itself. Used by the MIDs and Applications tabs.
 *
 * @param {"partner"|"parent"} variant
 * @param {string} noun  e.g. "MIDs", "MID applications"
 */
export default function ContainerScopeNotice({ variant, noun = "records" }) {
  const owner = variant === "partner" ? "attributed clients" : "child companies";
  const container = variant === "partner" ? "partner company" : "parent company";
  return (
    <div className="mb-4 flex items-start gap-2 rounded-lg border border-border bg-muted/50 px-4 py-3 text-sm text-muted-foreground">
      <Info className="mt-0.5 h-4 w-4 flex-shrink-0" />
      <span>
        These {noun} belong to this company's{" "}
        <span className="font-medium text-foreground">{owner}</span>, not the{" "}
        {container} itself.
      </span>
    </div>
  );
}
